import { TRootState } from 'Redux/Reducers';

export const getDailySales = (state: TRootState) => state.sales.entries.days || [];
